import type AiCostCallView from '@UI/Store/AiCosts/Views/AiCostCallView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * `list` holds the pages loaded so far (`loadedPage` is the last one, 0-indexed); `accountId` and
 * `queryKey` (period) scope it; `totalRecords` is the server total.
 */
class AiCostCallsListView {
	readonly list: readonly AiCostCallView[];
	readonly accountId: number;
	readonly queryKey: string;
	readonly totalRecords: number;
	readonly loadedPage: number;

	constructor(
		list: readonly AiCostCallView[],
		accountId: number,
		queryKey: string,
		totalRecords: number,
		loadedPage: number,
	) {
		this.list = list;
		this.accountId = accountId;
		this.queryKey = queryKey;
		this.totalRecords = totalRecords;
		this.loadedPage = loadedPage;

		Object.freeze(this);
	}

	get remainingCount(): number {
		return Math.max(0, this.totalRecords - this.list.length);
	}

	get hasMore(): boolean {
		return this.remainingCount > 0;
	}

	append(rows: readonly AiCostCallView[], page: number): AiCostCallsListView {
		return new AiCostCallsListView(
			[...this.list, ...rows],
			this.accountId,
			this.queryKey,
			this.totalRecords,
			page,
		);
	}
}

export default AiCostCallsListView;
